import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog } from '@mui/material'
import { useSelector } from 'react-redux';
import { useAuthContext } from '../../hooks/agencyAuthHook'
import toast from 'react-hot-toast'
import ConfigurationsHook from '../../hooks/ConfigurationsHook';
import PackagesHook from '../../hooks/PackagesHook';
import BookingHook from '../../hooks/BookingHook';
import InstructionsHook from '../../hooks/InstructionsHook';
import VoucherColorsHook from '../../hooks/VoucherColorsHook';
import {Link} from 'react-router-dom'

import logo from '../../assets/images/gohijaz.png'
export default function Vouchers() {
  const { getConfigurations } = ConfigurationsHook();
  const { getPackages } = PackagesHook();
  const { getBookings } = BookingHook();
    const { getInstructions } = InstructionsHook();
    const { getVoucherColors } = VoucherColorsHook();
  
  useEffect(() => {
    document.title = "Booking Vouchers"
    getBookings()
    getPackages()
    getConfigurations()
    getInstructions()
    getVoucherColors()
  }, [])


  const profile = useSelector((state) => state.profile.profile);
  const instructions = useSelector((state) => state.instructions.instructions);
  const vouchercolors = useSelector((state) => state.vouchercolors.vouchercolors);
  const bookings = useSelector((state) => state.bookings.bookings);


  // Paginate the filtered categories
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
   // Handle pagination change
   const handlePageChange = (event, value) => {
    setPage(value);
  };
  const paginatedBookings = bookings && bookings.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );



  const VoucherPrint = (booking,gender) => {
    if (!booking) {
      toast.error('Missing required booking details');
      return;
    }


  // Create a hidden iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);
document.title=`${booking.members[0].name}'s Voucher`

    // Wait for external stylesheets to load before writing the content
    const printContentString = `
    <!DOCTYPE html>
      <html>
        <head>
          <!-- Bootstrap CSS -->
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
          
          <!-- Font Awesome CSS -->
             <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" integrity="sha512-Evv84Mr4kqVGRNSgIGL/F/aIDqQb7xQ2vcrdIwxfjThSH8CSR7PBEakCr51Ck+w+/U6swU2Im1vVX0SVk9ABhg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
          <!-- Google Material Icons -->
          <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
       <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
          <link href="https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu&display=swap" rel="stylesheet">
          <title>${booking.members[0].name} Booking Voucher</title>
          <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Noto+Nastaliq+Urdu:wght@400..700&display=swap');

            @page {
            size: A4;
            margin: 0.2cm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
          }
            .header-container span {
              color: #6D76A1;
              font-size: 10px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container strong {
              color: #000;
              font-size: 11px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container h4 {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              padding:0px
            }
            .header-container small {
              color: #6D76A1;
              text-align: center;
              font-size: 12px;
              font-weight: 500;
              margin:0px;
              padding:0px;
              display:block;
            }

             .header-container .shirka_logo{
             height:40px;
             width:40px;
             }

            .header-container .shirka_logo img{
             height:100%;
             width:100%;
             border-radius:10px;
             object-fit: cover;
             }

            .info_row {
              border-radius: 10px;
             
            }
            .info_row h6 {
             color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              font-size: 14px;
              font-weight: 600;
            }
            .header-logo {
              width: 55px;
              height:55px;
              border-radius:10px;
              object-fit: cover;
            }
           
             
           .table-wrapper {
                border-radius: 5px;
                overflow: hidden;
              }
                .table .thead1{
             background: ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
              
              border:1px solid ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
                }
                .table .thead2{
             background: ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
             
                border:1px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
                }
            .table th {
             color: black;
           
              font-size: 9px;
              font-weight: 600;
              text-transform:capitalize;
              padding:1.5px;
              border:0px;
            }
              .table tbody{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};

              }
              .table tbody tr{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
              }
            .table td {
              color: #0C0B0B;
              font-size: 8px;
              font-weight: 500;
              text-transform:capitalize;
              padding:1.4px;
              border:0px;
            }

            table, tr, td {
              page-break-inside: avoid; /* Prevent splitting tables */
            }
            .instruction, .contact {
              page-break-inside: avoid; /* Prevent breaking within these sections */
            }
              .instruction p, .contact {
                page-break-inside: auto; /* Allow breaking if content is too large */
              }

             .instruction .header {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
             
              font-size: 13px;
              font-weight: 600;
            }
               .instruction .inner{
               border-radius:4px;
               height:auto;
               }
            
            // .instruction .urdu_paragraph *{
            //   font-size: 8px;
            //   line-height: 2.3 !important;
            //   margin: 0;
            //   padding: 0;
            // }
            .ql-align-left {
                text-align: left !important;
                direction: ltr;
              }

              .ql-align-center {
                text-align: center !important;
                direction: ltr;
              }

              .ql-align-right {
                text-align: right !important;
                direction: rtl;
              }
             .urdu_font{
            font-family: "Noto Nastaliq Urdu", serif;
            }
            
            .instruction hr{
            height:1px;
            color: #E4E4E4;
            }

            .contact {
                align-self: flex-start;
              }

            .contact .inner{  
               border-radius:4px;
              
               }
            .contact .header{
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
              font-size: 13px;
              font-weight: 600;
            }
            .contact strong{
           color: #454545;
            font-size: 10px;
            font-weight: 500;
            text-transform:capitalize;
              }

            .contact p{
            color: #454545;
            font-size: 10px;
            font-weight: 400;
              }
            .contact hr{
            height:1px;
            color: #E4E4E4;
            }

            .fixed-footer {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                z-index: 10;
                box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
                background:black;
                border-radius:4px;
              }
              .fixed-footer i{
              color:#CF9137;
              font-size:18px;
              margin:0px 3px 0px 3px;
              }
             
               .fixed-footer .left span{
              color:#CF9137;
              font-size:16px;
              font-weight:500;
              }
              .fixed-footer .middle img{
              height:40px;
              width:40px;
              }
              .fixed-footer .right span{
              color:#CF9137;
              font-size:12px;

              }
          </style>
        </head>
        <body>
          <div class="container-fluid mb-1 bg-white">
            <div class="row align-items-center mb-0 header-container p-0">
              <div class="col-3 text-start pt-0 mt-0">
                <div class="border py-2 px-3 rounded mt-0">
                  <div class='d-flex justify-content-between'>
                    <span class=" text-start">Voucher number</span>
                    <strong class="text-end">${booking.voucher_number||''}</strong>
                  </div>
                  <div class='d-flex justify-content-between'>
                    <span class="text-start">Created date</span>
                    <strong class="text-end">${new Date(booking.createdAt).toLocaleDateString()}</strong>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center pt-0">
                <img src="${profile&&profile.logo_on_voucher?profile.profile_pic:profile.agencyLogo}" alt="Agency Logo" class="header-logo mb-2">
                <h4>${profile?.name?.length>30?`${profile?.name?.slice(0,30)}...`:profile?.name}</h4>
                <small class="text-muted pb-0">${profile&&profile.address_on_print? (profile?.address?.length>30?`${profile?.address?.slice(0,30)}...`:profile?.address):profile?.agencyAddress?.length>30?`${profile?.agencyAddress?.slice(0,30)}...`:profile?.agencyAddress}</small>
                <small class="text-muted py-0">${profile?.phone?.length>25?`${profile?.phone?.slice(0,25)}...`:profile?.phone}</small>
              </div>
              <div class="col-3 text-start border py-2 px-3 rounded mt-0">
               <div class='d-flex justify-content-between'>
               <div>
                <span class="text-muted">Shirka</span><br />
                <strong>${booking?.shirka?.length>13?`${booking?.shirka?.slice(0,13)}...`:booking?.shirka}</strong>
               </div>
               
               <div>
               <div class='shirka_logo my-auto'>
               ${booking.shirka_logo
                ? `<img src="${booking.shirka_logo}" alt="" class="header-logo my-auto">`
                : ""
              }              
               </div>
               </div>

               </div>
              </div>
            </div>
  
            <div class="row info_row pt-1 pb-2 px-3">
              <div class='col-12 py-0 my-1'>
              
              <div class=" table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>General Information About Service</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Adult</th>
                      <th class="text-center">Children</th>
                      <th class="text-center">Infants</th>
                      <th class="text-center">Departure Date</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>${booking.adults||0}</td>
                      <td class="text-center">${booking.children||0}</td>
                      <td class="text-center">${booking.infants||0}</td>
                        <td class="text-center">${booking.departure_flight.departure_flight_date}</td>
                        
                        <td class="text-center">${booking.arrival_flight.arrival_flight_date}</td>
                     
                      <td class=' text-center'>${booking.duration||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
  
              <div class='col-12 py-0 my-1'>
             
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Departure Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>${booking.departure_flight.departure_location ||'Nill'}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_number||"Nill"}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_class||"Nill"}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_date}</td>
                     
                      <td class="text-center">${booking.departure_flight.departure_time||"Nill"}</td>
                       <td class="text-center">${booking.departure_flight.departure_to_flight_date}</td>
                     
                      <td class='text-center'>${booking.departure_flight.departure_to_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
             
  
              <div class='col-12 py-0 my-1'>
            
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Return Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class=' text-center'>${booking.arrival_flight.arrival_location||"Nill"}</td>
                      <td class="text-center">${booking.arrival_flight.arrival_flight_number||"Nill"}</td>
                      <td class="text-center">${booking.arrival_flight.arrival_flight_class||"Nill"}</td>

                      <td class="text-center">${booking.arrival_flight.arrival_flight_date}</td>
                     
                      <td class="text-center">${booking.arrival_flight.arrival_time}</td>

                       <td class="text-center">${booking.arrival_flight.take_off_flight_date}</td>

                     
                      <td class='text-center'>${booking.arrival_flight.take_off_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            
              
              <div class='col-12 py-0 my-1'>
               ${booking.isHotel ? `
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Accommodation Detail</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">City</th>
                      <th class="text-center">Hotel</th>
                      <th class="text-center">Check in</th>
                      <th class="text-center">Check out</th>
                      <th class="text-center">Room type</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${booking.accomodation_details.map(accom => `
                      <tr class='py-0 my-0'>
                        <td class='text-center'>${accom.hotel_city||"Nill"}</td>
                        <td class="text-center">${accom.hotel_name||"Nill"}</td>

                         <td class="text-center">${accom.check_in_date}</td>
                        <td class="text-center">${accom.check_out_date}</td>
                      
                       
                        <td class="text-center">${booking.room_type||"Nill"}</td>
                        <td class='text-center'>${accom.hotel_duration||"Nill"}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>` : ''}
              </div>
  
             

              <div class='col-12 py-0 my-1''>
              
               <h6 class="mb-1">Transportation Details</h6>
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Transportation Details</strong></th>
                       <th colspan='2'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class='text-center'>Trasnport</th>
                      <th class='text-center'>Trasnport Services For</th>
                      <th class='text-center'>Ziyarat</th>
                      
                    </tr>
                  </thead>
                  <tbody >
                    <tr>
                      <td class='text-center'>${booking.transport_details||"Nill"}</td>
                      <td class='text-center'>${booking.transport_services_for||"Nill"}</td>
                      <td class='text-center'>${booking.ziyarat||"Nill"}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>

  
              <div class='col-12 py-0 my-0''>
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Mutamer's (Pilgrims) Details</strong></th>
                       <th colspan='7'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2' >
                    <tr>
                      <th class="text-center">Pilgrim name</th>
                      <th class="text-center">Passport No</th>
                      <th class="text-center">DOB</th>
                      <th class="text-center">Age Group</th>
                      <th class="text-center">Visa no</th>
                      <th class="text-center">Issue date</th>
                      <th class="text-center">Group code</th>
                      <th class="text-center">Mofa Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${booking.members.filter(member=>(gender?member.gender.toLowerCase()===gender.toLowerCase():member.gender)).map(member => `
                      <tr>
                        <td class=' text-center'>${member.name}</td>
                        <td class="text-center">${member.ppNo}</td>

                        <td class="text-center">${member.dob}</td>
                        <td class="text-center">${member.age_group}</td>
                        <td class="text-center">${member.visa_number}</td>

                        <td class="text-center">${member.visa_issue_date}</td>
                      
                        <td class="text-center">${booking.group_code}</td>

                         <td class="text-center">${member.mofa_date}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>
              </div>
              
            <div class='col-9 mt-1 py-0 instruction ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-2 text-end ':'order-1 text-start '}'>
            <div class='px-2 border inner pt-2 pb-3 '> 
            <h6 class="header ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start english_font mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'اہم ہدایات':'Instructions'}</h6>
            ${(!instructions || !instructions.content?.trim() || instructions.content.trim() === '<p><br></p>') 
                ? `<p class='paragraph'>During Hajj or Umrah, pilgrims should first ensure they are in a state of Ihram, which involves wearing specific garments and making the intention to perform the pilgrimage. Upon arrival in Makkah, the first step is to perform Tawaf, circling the Kaaba seven times in a counterclockwise direction. After Tawaf, pilgrims should perform Sa'i, walking seven times between the hills of Safa and Marwah. It's important to stay hydrated and maintain a respectful demeanor throughout the journey. Finally, remember to engage in prayers and reflection, making the most of this spiritual experience.</p>` 
                : ""}
                ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&!instructions.isUrdu)? `<p class='paragraph'>${instructions?.content}</p>` 
                  : ""}
                  <div class='urdu_paragraph'>
                   ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&instructions.isUrdu)? `<h5 class=''>${instructions?.content}</h5>` 
                  : ""}
                  </div>
               
            
          
            </div>
            
             </div>

           <div class='col-3 mt-1 py-0 contact ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-1 text-end':'order-2 text-start'}'>
           <div class='p-2 border inner'> 
            <h6 class="header ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'رابطہ کی تفصیلات':'Contact'}</h6>
          
            ${profile.focal_persons.map(person =>
                  ` 
              <div class='d-flex justify-content-between'>
                <strong>${person.city} / ${person.name}</strong>
                <p>${person.phone}</p>
              </div>
              `).join('')}
           </div>
           
          </div>


          
            </div>

           <div class="fixed-footer px-2 py-1 text-center">
          <div class='d-flex justify-content-between my-auto'>
          <div class="left my-auto">
          <i class="fa-brands fa-linkedin"></i>
          <i class="fa-brands fa-square-facebook"></i>
          <i class="fa-brands fa-instagram"></i>
          <i class="fa-brands fa-square-x-twitter"></i>
          <i class="fa-brands fa-tiktok"></i>
          <i class="fa-brands fa-youtube"></i>
          <i class="fa-brands fa-pinterest"></i>
          <i class="fa-brands fa-quora"></i>
          <span class='ms-1'>@Gohijaz</span>
          </div>
          <div class="middle my-auto">
          <img src=${logo} alt=''/>
          </div>
          <div class="right my-auto">
          <i class="fa-brands fa-edge"></i> <span> www.gohijaz.com</span>
          <i class="fa-solid fa-phone"></i> <span> +92 000 000 0000</span>
          
          </div>
          </div>
        </div>
            
          </div>
        </body>
      </html>
    `;
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(printContentString);
    iframe.contentWindow.document.close();
  

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe); 
document.title=`Booking Vouchers`
    }, 500);

  }

  const collapsed = useSelector((state) => state.collapsed.collapsed);
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
          <div className="row px-2 mt-5 pt-4">
            <div className="col-md-12 data_table p-2 pb-3">
              <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-3 my-auto">
                <div className="d-flex left my-auto mb-2 mb-md-0 ps-3 ps-md-0">
                  <h6>Vouchers</h6>
                </div>
                <div className="d-flex right my-auto">
                  {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
              <input type="text"  value={search} onChange={handleSearchChange} placeholder='Seacrh..' /> */}
                  
                </div>
              </div>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                  <TableHead >
                    <TableRow >
                      <TableCell className='th text-center' >SN</TableCell>
                      <TableCell className='th text-center' >Voucher #</TableCell>
                      <TableCell className='th text-center'>Members</TableCell>
                      <TableCell className='th text-center'>Agency</TableCell>
                      <TableCell className='th text-center'>Package Name</TableCell>
                      <TableCell className='th text-center'>Package Price</TableCell>
                      <TableCell className='th text-center'>Duration</TableCell>
                      <TableCell className='th text-center'>Date (from/to)</TableCell>
                      <TableCell className='th text-center'>Travel Plan</TableCell>
                      <TableCell className='th text-center'>Action</TableCell>
                      
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedBookings && paginatedBookings.length > 0 ? paginatedBookings
                    .filter(b=>b.isApproved)
                      .map((data, index) => (
                        <>
                          <TableRow className='table_row'>
                            <TableCell className='text-center td'>{index + 1}</TableCell>
                            <TableCell className='text-center td'>{data?.voucher_number||''}</TableCell>
                            <TableCell className='text-center td'>{data.members.length}</TableCell>
                            <TableCell className='text-center td'>{data.agencyName}</TableCell>
                            <TableCell className='text-center td'>{data.packageName}</TableCell>
                            <TableCell className='text-center td'>{data.totalPrice.toLocaleString()}</TableCell>
                            <TableCell className='text-center td'>{data.duration} days</TableCell>
                            <TableCell className='text-center td'>{data.departure_flight.departure_flight_date} to {data.arrival_flight.arrival_flight_date}</TableCell>
                            <TableCell className='text-center td'>{data.package_header?.includes('umrah') ? "Umrah" : "Hajj"}</TableCell>
                            <TableCell className='text-center td'>
                            {(data.package_header?.includes('umrah'))&&
                              <div className="dropdown">
                              <button type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                              <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.7847 14.5873C24.7847 14.5873 24.7874 14.0396 24.7874 13.4202C24.7874 8.1939 24.7874 5.58073 23.1643 3.95711C21.5412 2.3335 18.9288 2.3335 13.7041 2.3335C8.47934 2.3335 5.86698 2.3335 4.24386 3.95711C2.62074 5.58073 2.62074 8.1939 2.62074 13.4202C2.62074 18.6466 2.62074 21.2598 4.24386 22.8834C5.6049 24.2448 7.66153 24.4647 11.3707 24.5002" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M2.62074 8.16699H24.7874" stroke="#6D76A1" stroke-width="1.5" stroke-linejoin="round" />
                                    <path d="M7.28741 18.6667H8.45408M11.9541 14H17.7874M7.28741 14H8.45408" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.1207 21.5835H20.1312" stroke="#6D76A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M25.6881 21.0262C25.8654 21.2749 25.9541 21.3993 25.9541 21.5833C25.9541 21.7674 25.8654 21.8917 25.6881 22.1404C24.8912 23.2578 22.8561 25.6667 20.1207 25.6667C17.3854 25.6667 15.3503 23.2578 14.5534 22.1404C14.3761 21.8917 14.2874 21.7674 14.2874 21.5833C14.2874 21.3993 14.3761 21.2749 14.5534 21.0262C15.3503 19.9088 17.3854 17.5 20.1207 17.5C22.8561 17.5 24.8912 19.9088 25.6881 21.0262Z" stroke="#6D76A1" stroke-width="1.5" />
                                  </svg>
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'')}>Combine Voucher</Link></li>
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'male')}>Males  Voucher</Link></li>
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'female')}>Females Voucher </Link></li>
                              </ul>
                            </div>
                              }

                            </TableCell>
                            
                          </TableRow>
                          <hr />
                        </>
                      )) :
                      <TableRow className='table_row' sx={{ marginBottom: 2 }}>
                        <TableCell colSpan={5} className='text-center td'></TableCell>
                        <TableCell className='text-center td'>No result</TableCell>
                        <TableCell colSpan={4} className='text-center td'></TableCell>
                      </TableRow>

                    }
                  </TableBody>
                </Table>

              </TableContainer>
              {/* Pagination */}
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  count={Math.ceil(bookings.length / rowsPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  className="custom-pagination"

                />
              </div>
            </div>
          </div>
      </div>
      
    </div>
  )
}
